import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessIndexStatus: 'idle',
    startProcessIndexError: undefined as any,
    loadUserParamsProcessIndexStatus: 'idle',
    loadUserParamsProcessIndexError: undefined as any,

    processIndexList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessIndex = createAsyncThunk('processIndexSlice/startProcessIndex', async ({ processIndex }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessIndex/`,
        prepareData(processIndex),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessIndexStatus } = getState().processIndexSlice
        return startProcessIndexStatus !== 'pending'
    }
})

export const loadUserParamsProcessIndex = createAsyncThunk('processIndexSlice/loadUserParamsProcessIndex', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessIndex/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessIndexStatus } = getState().processIndexSlice
        return loadUserParamsProcessIndexStatus !== 'pending'
    }
})

const ProcessIndexSlice = createSlice({
    name: 'processIndexSlice',
    initialState,
    reducers: {
        resetstartProcessIndex: (state) => {
            state.job = undefined
            state.startProcessIndexError = undefined
        },
        resetstartProcessIndexError: (state) => {
            state.startProcessIndexError = undefined
        },
        resetloadUserParamsProcessIndex: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessIndexError = undefined
        },
        resetloadUserParamsProcessIndexError: (state) => {
            state.loadUserParamsProcessIndexError = undefined
        },
        removeFromProcessIndexListById: (state, action) => {
            state.processIndexList = state.processIndexList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessIndexListByIds: (state, action) => {
            state.processIndexList = state.processIndexList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processIndexList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessIndexStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processIndexList = []
            state.startProcessIndexStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessIndex.pending, (state) => {
            state.startProcessIndexStatus = 'pending'
            state.startProcessIndexError = undefined
        })
        builder.addCase(startProcessIndex.fulfilled, (state, action) => {
            state.startProcessIndexStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessIndex.rejected, (state, action) => {
            state.startProcessIndexStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessIndexError = action.error.message
            } else {
                state.startProcessIndexError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessIndex.pending, (state) => {
            state.loadUserParamsProcessIndexStatus = 'pending'
            state.loadUserParamsProcessIndexError = undefined
        })
        builder.addCase(loadUserParamsProcessIndex.fulfilled, (state, action) => {
            state.loadUserParamsProcessIndexStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessIndex.rejected, (state, action) => {
            state.loadUserParamsProcessIndexStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessIndexError = action.error.message
            } else {
                state.loadUserParamsProcessIndexError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessIndex,
    resetstartProcessIndexError,
    resetloadUserParamsProcessIndex,
    resetloadUserParamsProcessIndexError,
    removeFromProcessIndexListById,
    removeFromProcessIndexListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessIndexSlice.actions
export default ProcessIndexSlice.reducer
